import React, { useContext } from "react"
import { ThemeContext } from "styled-components";
import { AppendIcon, Container, PrependIcon } from "./styles";

interface Props {
    onClick: () => void;
    size?: "small" | "medium" | "large";
    color?: keyof ISystemColors,
    prependIcon?: string;
    appendIcon?: string;
    disabled?: boolean;
    loading?: boolean;
}

const SimpleButton: React.FC<Props> = ({
    onClick,
    children,
    prependIcon,
    appendIcon,
    disabled,
    loading,
    color = "primary",
    size = "medium" }) => {
    const theme = useContext(ThemeContext);

    const iconSize = () => {
        switch (size) {
            case "small":
                return 12;
            case "large":
                return 24;
            default:
                return 16;
        }
    }

    return <Container color={color} size={size} disabled={disabled} onClick={() => {
        if (!disabled) onClick();
    }}>
        {prependIcon !== undefined && <PrependIcon loading={loading} icon={loading ? 'loading' : prependIcon} size={iconSize()} color={theme.textColor[color]} />}
        {children}
        {appendIcon !== undefined && <AppendIcon loading={loading} icon={loading ? 'loading' : appendIcon} size={iconSize()} color={theme.textColor[color]} />}
    </Container>
}

export default SimpleButton;